export const isAuthenticated = (state) => {
  return state.auth.isAuthenticated || false;
};
